import { cx, RadioButton } from "@light-technology/components";
import { type BrandMode } from "../../state/api.types";
import { BrandModePreview } from "./BrandModePreview";

type BrandModeOptionProps = {
  value: BrandMode;
  label: string;
  title: string;
  logoSrc: string | null;
  isSelected: boolean;
};

export const BrandModeOption = (props: BrandModeOptionProps) => {
  return (
    <div className="flex w-[200px] flex-col gap-xl">
      <div className="relative">
        <BrandModePreview
          className={cx(
            "block h-[132px] w-[200px] rounded-xl",
            props.isSelected && "outline-2 outline-offset-2 outline-focus-ring",
          )}
          src={props.logoSrc}
          title={props.title}
        />
        <RadioButton
          value={props.value}
          aria-label={props.label}
          className="absolute inset-0 cursor-pointer items-end justify-start p-2"
        />
      </div>
      <span className="text-sm font-semibold">{props.label}</span>
    </div>
  );
};
